import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import { UserProvider } from '@fff-web/fff-utilities';
import AnalyticsWrapper from './AnalyticsWrapper';
import App from './components/App';
import env from './config/env';
import './style/fabfitfun.css';
import { StrictMode } from 'react';
import { initDatadogRum } from './utils/datadog';

const tagManagerArgs = {
  gtmId: env.REACT_APP_GTM_CONTAINER_ID,
};
TagManager.initialize(tagManagerArgs);

initDatadogRum();

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
} as Record<string, string>;

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: env.LAUNCHDARKLY_ID,
  });

  const container = document.getElementById('root');
  const root = createRoot(container!);
  root.render(
    <StrictMode>
      <FFFErrorBoundary>
        <UniversalNavigationContextProvider>
          <Router>
            <LDProvider>
              <QueryParamProvider adapter={ReactRouter6Adapter}>
                <UserProvider>
                  <AnalyticsWrapper>
                    <App />
                  </AnalyticsWrapper>
                </UserProvider>
              </QueryParamProvider>
            </LDProvider>
          </Router>
        </UniversalNavigationContextProvider>
      </FFFErrorBoundary>
    </StrictMode>,
  );
})();
